import { setIsActiveSpinner } from "../../Redux/GeneralSlice";
import UserService from "../../Services/http/UserService";


const getMonthlyFees = async (dispatch, user_id=null) => {
    dispatch(setIsActiveSpinner(true));
    const response = await UserService.getMonthlyFees(user_id);
    dispatch(setIsActiveSpinner(false));
    return response;
};

const downloadReportMonthlyFees = async (dispatch, user_id=null) => {
    dispatch(setIsActiveSpinner(true));
    await UserService.downloadReportMonthlyFees(user_id);
    dispatch(setIsActiveSpinner(false));
};

const MonthlyFeesUtils = {
    getMonthlyFees,
    downloadReportMonthlyFees
};

export default MonthlyFeesUtils;